import React, { useState, useEffect } from "react";
import "../../styles/SearchResultsRHS.css";
import { POSP_ARABLE_HEADERS } from "../../utils/TableHeaders.tsx";
import Map from "../../components/UI/Map.tsx";
import { useDispatch, useSelector } from "react-redux";
import {
  getCropData,
  getPOSPCount,
  getPOSPTargetData,
  getSelectedGeometry,
  getStateData,
} from "../../services/MapApi.tsx";
import { ColumnHeaderType } from "../../utils/Types.tsx";
import {
  ACTIVE_VIEW_STATE,
  COLOR,
  COMBINED_LEVELS_FILTER,
  TABLE_SORT_ASC,
  DATE_FORMAT,
  ALL_CROPS,
  ALL_STATE,
  SCREEN_TYPE,
  NEW_CROP_API_LEVEL,
  NOC_LEVEL,
  MAP_VIEW,
} from "../../utils/Constants.tsx";
import {
  formatNumber,
  parseStateData,
  sortListItems,
} from "../../utils/Util.tsx";
import {
  handlePOSPTarget,
  handleStateGridLatLng,
  handleStoreMarkers,
} from "../../redux/slices/mapApiSlice.ts";
import moment from "moment";
const getGridIdWiseData = (list, levelOne, levelTwo) => {
  const result = list?.reduce((acc, item) => {
    acc[item.gridid] = { ...item, levelOne, levelTwo };
    return acc;
  }, {});
  return result;
};
interface SearchResultsRHSProps {
  setGridId: (data: string) => void;
  gridId: string;
  isLoading: boolean;
  levelOne: string;
  levelTwo: string;
  setIsLoading: (value: boolean) => void;
  setLevelOne: (level: string) => void;
  setLevelTwo: (level: string) => void;
}

const NocMap = ({
  setGridId,
  gridId,
  isLoading,
  levelOne,
  levelTwo,
  setIsLoading,
  setLevelOne,
  setLevelTwo,
}: SearchResultsRHSProps) => {
  const [columnHeaders, setColumnHeaders] = useState<ColumnHeaderType[]>([]);
  const [mapClickedInfo, setMapClickedInfo] = useState(null);
  const [canShowToolTip, setCanShowToolTip] = useState(false);
  const [selectedState, setSelectedState] = useState({ sid: ALL_STATE });
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [gridWiseData, setGridIdWiseData] = useState(null);
  const [stateTableData, setStateTableData] = useState(null);
  const [mapToolTip, setMapToolTip] = useState(null);
  const [markerType, setMarkersType] = useState<string[]>([]);
  const [legendStyle, setLegendStyle] = useState(null);
  const [intervalIndex, setIntervalIndex] = useState(0);
  const [isGridViewSelected, setGridViewSelected] = useState(true);
  const [title,setTitle]=useState(levelTwo)

  const dispatch: any = useDispatch();

  const { stateViewData, selectedGeometry, legendValues } = useSelector(
    (state: any) => state.map
  );
  const stateArray = useSelector(
    (state: any) => state?.country?.countryStateData
  );
  const stateNameMarkers = useSelector((state: any) => state.map.markersStore);
  const refreshTime = useSelector((state: any) => state.login.refreshTime);

  const gridLatLng = useSelector((state: any) => state?.map?.gridLatLng);
  const screenType = useSelector((state: any) => state?.login?.screenType);

  useEffect(() => {
    if (stateArray?.length) {
      dispatch(handleStoreMarkers({ marker: "state", res: stateArray }));
      setMarkersType(["state"]);
    }
  }, [stateArray]);

  useEffect(() => {
    if (mapToolTip?.gridid) {
      setGridId(mapToolTip.gridid);
    }
  }, [mapToolTip]);

  useEffect(() => {
    if (mapClickedInfo?.gridid && canShowToolTip) {
      setMapToolTip({
        ...gridWiseData[mapClickedInfo?.gridid],
        gridid: mapClickedInfo?.gridid,
      });
      dispatch(
        getSelectedGeometry(
          { lat: mapClickedInfo.lat, lng: mapClickedInfo.lng },
          ACTIVE_VIEW_STATE
        )
      );
    }
    if (stateViewData?.data) {
      updateTableData(mapClickedInfo?.gridid);
    }
  }, [mapClickedInfo]);

  useEffect(() => {
    if (!gridId && stateViewData?.data) {
      updateTableData();
    }
  }, [gridId]);

  const getStateRangeValue = (minValue, maxValue) => {
    return {
      minValue: formatNumber(minValue),
      maxValue: formatNumber(maxValue),
      minColor:
        screenType === SCREEN_TYPE.NOC ? COLOR.country.min : COLOR.state.min,
      maxColor:
        screenType === SCREEN_TYPE.NOC ? COLOR.country.max : COLOR.state.max,
    };
  };

  const updateHeader = (
    levelOne: string,
    levelTwo: string,
    aggregated: any
  ) => {
    switch (levelOne + "-" + levelTwo) {
      case COMBINED_LEVELS_FILTER.POSPm_POSP:
        // setChartTitle("POSP'S DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_posp_count,
            legendValues?.max_posp_count
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.POSPm_TARGET:
        // setChartTitle("TARGET DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_target_value,
            legendValues?.max_target_value
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.POSPm_ARABLE:
        setColumnHeaders(POSP_ARABLE_HEADERS);
        // setChartTitle("ARABLE DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_catchment_ratio,
            legendValues?.max_catchment_ratio
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Policy_Customer_Count:
        // setChartTitle("CUSTOMER COUNT DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_customers,
            legendValues?.max_customers
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Policy_Policy_Count:
        // setChartTitle("Product Contribution Based On Policy Count");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_policies,
            legendValues?.max_policies
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Policy_Premium:
        // setChartTitle("PREMIUM DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_premium,
            legendValues?.max_premium
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Policy_Sum_Insured:
        // setChartTitle("SUM INSURED DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_suminsured,
            legendValues?.max_suminsured
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Policy_Insured_Area:
        // setChartTitle("INSURED AREA DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_area,
            legendValues?.max_area
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Claim_Processed:
        // setChartTitle("CLAIM PROCESSED DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_claim_count,
            legendValues?.max_claim_count
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Claim_Pending:
        // setChartTitle("CLAIM PENDING DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_claim_count,
            legendValues?.max_claim_count
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Customer_Count:
        // setChartTitle("CUSTOMER COUNT DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_customer_count,
            legendValues?.max_customer_count
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Amount_Disbursed:
        // setChartTitle("AMOUNT DISBURSED DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_payout_amount,
            legendValues?.max_payout_amount
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Amount_Can_Be_Disbursed:
        // setChartTitle("AMOUNT CAN BE DISBURSED DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_payout_amount,
            legendValues?.max_payout_amount
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Loss_Ratio:
        // setChartTitle("LOSS RATIO(CLAIM/PREMIUM) DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_loss_ratio,
            legendValues?.max_loss_ratio
          )
        );
        break;
      case COMBINED_LEVELS_FILTER.Claims_Total_Claim_Count:
        // setChartTitle("TOTAL CLAIM COUNT DETAILS");
        setLegendStyle(
          getStateRangeValue(
            legendValues?.min_claim_count,
            legendValues?.max_claim_count
          )
        );
        break;
      default:
        setColumnHeaders([]);
      // setChartTitle("");
    }
  };

  const getNocStateViewData = (
    level1: string,
    level2: string,
    startDate: string,
    endDate: string
  ) => {
    const data: any = {
      level3: ALL_CROPS,
      level1: level1,
      level2: level2 ==="Amount Disbursed"||level2==="Pending Claims"? "Total Claim Count":level2,
    };
   
    setIsLoading(true);
    if (NEW_CROP_API_LEVEL.includes(level2)) {
      dispatch(getCropData({...data, startdate: startDate, enddate: endDate}));
    } else if (level1 === "POSPm") {
      dispatch(getCropData({ ...data, level1: "POSPM", level2: "POSPM" }));
      dispatch(getPOSPCount({ ...data, level1: "POSPM", level2: "POSP" }));
      dispatch(getPOSPTargetData({ ...data, level2: "Target", startdate: startDate, enddate: endDate }));
    }

    if (level1 === "POSPm") {
      dispatch(getStateData({ ...data, level2: "POSP" }));
    } else {
      dispatch(getStateData({...data, startdate: startDate, enddate: endDate}));
    }
  };
  useEffect(() => {
    setLevelOne(NOC_LEVEL[intervalIndex].levelOne);
    setLevelTwo(NOC_LEVEL[intervalIndex].levelTwo);

    let startDate;
    let endDate;
    if (NOC_LEVEL[intervalIndex].levelOne === "Claims") {
        startDate = "2024-06-01";
        endDate = "2025-04-30";  
      
    } else  {
      startDate = "2025-05-01";
      endDate = moment().format(DATE_FORMAT.YYYY_MM_DD);
    }
    getNocStateViewData(
      NOC_LEVEL[intervalIndex].levelOne,
      NOC_LEVEL[intervalIndex].levelTwo,
      startDate,
      endDate
    );
  }, [intervalIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIntervalIndex((prevIndex) => {
        const nextIndex = prevIndex >= NOC_LEVEL.length - 1 ? 0 : prevIndex + 1;
        return nextIndex;
      });
    }, refreshTime);
    return () => clearInterval(interval);
  }, [refreshTime]);
  useEffect(()=>{
    setTitle(levelTwo)
  },[levelTwo])

  /**
   * Prepare data list to show in table.
   * @param gridid optional
   */
  const updateTableData = (gridid?: string) => {
    const dataArray = stateViewData?.data;
    updateHeader(levelOne, levelTwo, stateViewData?.aggregated);
    const itemArray = parseStateData(dataArray, levelOne, levelTwo, gridid);
    setStateTableData(sortListItems(itemArray, "gridid", TABLE_SORT_ASC));
  };
  useEffect(() => {
    if (stateViewData?.data && levelOne && levelTwo) {
      setGridIdWiseData(
        getGridIdWiseData(stateViewData?.data || [], levelOne, levelTwo)
      );
      updateTableData();
    } else {
      setGridIdWiseData(null);
      setStateTableData(null);
    }
  }, [stateViewData]);

  const sortTableItems = (sortBy, sortOrder) => {
    setStateTableData(sortListItems(stateTableData, sortBy, sortOrder));
  };
  return (
    <div className="noc-results-container">
      <div className="noc-map-title">
        {title} distribution at grid level
      </div>
      {/* <div className="form-switch switch d-flex justify-content-center ">
        <label className="form-check-label">View: </label>
        <label className="form-check-label switch-text ms-1">State</label>
        <input
          className="form-check-input ms-1"
          type="checkbox"
          id="flexSwitchCheckDefault"
          checked={isGridViewSelected}
          disabled={true}
          onChange={(value) => {
            setGridViewSelected(!isGridViewSelected);
          }}
        />
        <label className="form-check-label switch-text ms-2">Grid</label>
      </div> */}
      <div className="noc-map">
        <Map
          activeView={ACTIVE_VIEW_STATE}
          setGridId={setGridId}
          district={selectedDistrict}
          setMapClickedInfo={(mapInfo) => {
            dispatch(handleStateGridLatLng(null));
            setMapClickedInfo(mapInfo);
          }}
          mapClickedInfo={mapClickedInfo}
          mapToolTip={mapToolTip}
          showGridToolTip={canShowToolTip}
          state={selectedState}
          idWiseData={gridWiseData}
          legendStyle={legendStyle}
          legendValues={legendValues}
          filterName={levelOne + "-" + levelTwo}
          selectedGeometry={selectedGeometry}
          markerData={stateNameMarkers}
          markerType={markerType}
          screenType={screenType}
          mapView={
            isGridViewSelected ? MAP_VIEW.GRID_WISE : MAP_VIEW.STATE_WISE
          }
          gridCenter={
            gridLatLng?.properties
              ? [
                  Number(gridLatLng?.properties?.lat_cen),
                  Number(gridLatLng?.properties?.lon_cen),
                ]
              : null
          }
        />
      </div>
    </div>
  );
};

export default NocMap;
